import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

import {
  useConfgOrganizations,
  useConfgOrganizationConnect,
} from "../../hooks/confg/base";
import { useVaultSignout } from "../../hooks/vault/base";

import LOGO from "../../semiauth.logo.png";

const Connect = () => {
  const navigate = useNavigate();

  const signout = useVaultSignout();
  const connect = useConfgOrganizationConnect();
  const organizations = useConfgOrganizations();

  const [organizationId, setOrganizationId] = useState("");

  const submit = () => connect.mutate({ id: organizationId });

  const reset = () => {
    localStorage.removeItem("SEMIAUTH_ORG_ID");
    localStorage.removeItem("SEMIAUTH_ORG_URL");
    localStorage.removeItem("SEMIAUTH_ORG_NAME");

    setOrganizationId("");
  };

  const handleChange = (event: SelectChangeEvent) =>
    setOrganizationId(event.target.value as string);

  const Reset = () => (
    <IconButton onClick={reset}>
      <CancelIcon />
    </IconButton>
  );

  useEffect(() => {
    if (organizations.data?.meta.total === 1) {
      connect.mutate({ id: organizations.data.data[0].id });
    }
  }, [organizations.data?.meta.total]);

  useEffect(() => {
    if (connect.isSuccess) navigate("/home");
  }, [connect.isSuccess]);

  useEffect(() => {
    document.title = "[semiauth] | organization";
  }, []); // run once on mount

  return (
    <Container
      maxWidth="xs"
      component="main"
      sx={{
        display: "flex",
        textAlign: "center",
        alignItems: "center",
        marginBlock: "auto",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={LOGO} alt="[semiauth] logo" className="logo" />

        <Grid container spacing={4} width={400} paddingTop={2}>
          <Grid item sm={12} md={12}>
            {connect.isPending ? (
              "Connecting ..."
            ) : (
              <FormControl fullWidth>
                <InputLabel id="organization-select-label">Select</InputLabel>
                <Select
                  id="organization-select"
                  value={organizationId}
                  label={"Select"}
                  labelId="organization-select-label"
                  onChange={handleChange}
                  IconComponent={!!organizationId ? Reset : undefined}
                >
                  {organizations.data?.meta.total === 0 ? (
                    <MenuItem disabled key={"no-organization-found"} value={0}>
                      No organizations found
                    </MenuItem>
                  ) : (
                    organizations.data?.data.map((org) => (
                      <MenuItem value={org.id}>{org.name}</MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            )}
          </Grid>

          <Grid item sm={6} md={6}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => signout.mutate()}
            >
              Sign out
            </Button>
          </Grid>

          <Grid item sm={6} md={6}>
            <Button
              fullWidth
              variant="contained"
              onClick={submit}
              disabled={!organizationId}
            >
              Connect
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Connect;
